package ai.flowstorm.common.auth

import ai.flowstorm.common.ui.AuthLog
import ai.flowstorm.studio.util.now
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.math.min
import kotlin.math.pow

abstract class AbstractOAuth2Provider : JwtAuthProvider {

    val mainScope = MainScope()

    override lateinit var authService: AuthService

    private var expires: Int = 0 // in seconds

    @Suppress("unused")
    private val refreshJob = mainScope.launch {
        var delay = 2000L
        var faliures = 0
        while (true) {
            delay(delay)
            if (expires > 0 && expires < timestamp() + EXPIRE_IN_THRESHOLD) {
                AuthLog.timeLog("Token is about to expire. Refreshing.")
                try {
                    refreshToken()
                    faliures = 0
                    delay = 2000L
                } catch (t:Throwable ) {
                    faliures++
                    delay = min(15000 ,100 * 1.5.pow(faliures).toLong())
                    AuthLog.timeLog("Failed to refresh token. Trying again in $delay ms")
                }
            }
        }
    }

    protected fun timestamp() = now().epochSeconds.toInt()

    protected fun scheduleRefresh(expiresIn: Number) {
        AuthLog.timeLog("Token expires in ${expiresIn}s. Scheduled for refresh.")
        expires = timestamp() + expiresIn.toInt()
    }

    companion object {
        protected const val EXPIRE_IN_THRESHOLD = 120 // token is refreshed
    }
}